/**
 * @desc 调拨单获取唛头信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.allocationMaster.allocationBoxHeadDto.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/allocationMaster/allocationBoxHeadDto`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
